import { render, staticRenderFns } from "./DE.vue?vue&type=template&id=0f23ba79&scoped=true&"
import script from "./DE.vue?vue&type=script&lang=js&"
export * from "./DE.vue?vue&type=script&lang=js&"
import style0 from "./DE.vue?vue&type=style&index=0&id=0f23ba79&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f23ba79",
  null
  
)

export default component.exports